import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { LogService } from '../log/log.service';
import { PaymentType } from '../../event/models/payment-type';

@Pipe({
  name: 'paymentType'
})
export class PaymentTypePipe implements PipeTransform {

  constructor(
    private translateService: TranslateService,
    private logService: LogService) { }

  transform(value: any, args?: any): any {

    // Pipes need to handle nulls/undefined
    if (!value) {
      value = '';
    }

    value = value.toLowerCase().toString();

    let returnValue = '';

    switch (value) {
      case PaymentType.FINAL_PAYMENT:
        returnValue = this.translateService.instant('PAYMENT_TYPE.FINAL_PAYMENT');
        break;
      case PaymentType.PREPAYMENT:
        returnValue = this.translateService.instant('PAYMENT_TYPE.PREPAYMENT');
        break;
      default:
        this.logService.info(this.translateService.instant('PAYMENT_TYPE.UNKNOWN', { key: value }));
    }

    return returnValue;
  }

}



// WEBPACK FOOTER //
// /var/lib/jenkins/jobs/GroupPay/jobs/QA2/jobs/QA-Pioneer-ALL-2-POC/workspace/pioneer-web/src/app/shared/pipes/payment-type.pipe.ts